import React, { FunctionComponent } from 'react';

import { List, ListItem } from 'components/chroma';
import { replaceSpaces } from 'scenes/common/helpers/text';

export type HassleFreeClaimsContentProps = {
  supportBenefitsList: JSX.Element[];
  supportFootnote: JSX.Element;
  totalLossClaimsWording: JSX.Element;
  totalLossClaimsHeading: JSX.Element;
};

export const HassleFreeClaimsContent: FunctionComponent<HassleFreeClaimsContentProps> = ({
  supportBenefitsList,
  supportFootnote,
  totalLossClaimsWording,
  totalLossClaimsHeading,
}) => (
  <>
    <List bullet>
      {supportBenefitsList.map((benefit) => (
        <ListItem key={replaceSpaces(benefit.props.listkey)}>
          {benefit}
        </ListItem>
      ))}
    </List>
    {supportFootnote}
    {totalLossClaimsHeading}
    {totalLossClaimsWording}
  </>
);

export default HassleFreeClaimsContent;
